import React from 'react';
import config from 'config/componentsCore';
import { CONFIG } from 'config/config';
import routes from 'config/config/routes';
import { getTrackerWrapperTransports } from 'config/utils/getTrackerWrapperTransports';
import {
	ApplicationWrapper,
	BackendWrapper,
	NavigationWrapper,
	SessionWrapper,
	UiWrapper,
	EventTrackerWrapper,
} from '@coinscrap/webapp-core';
import AgentProvider from '../contexts/agent';
import { EntityWrappers } from './WrapEntitiesHandlers';

const WrappersComponent = ({ children }) => {
	const UiWrapperConfig = {
		...config,
		fontFamily: CONFIG.fonts.regular,
		colors: {
			main: CONFIG.colors.primary,
			secondary: CONFIG.colors.secondary,
			defaultFontColor: CONFIG.colors.black,
		},
	};

	const engine = EventTrackerWrapper.TRANSPORTS.GTM;
	const wrapperTransports = getTrackerWrapperTransports(engine);

	return (
		<ApplicationWrapper>
			<EventTrackerWrapper transports={wrapperTransports}>
				<BackendWrapper>
					<UiWrapper config={UiWrapperConfig} showDesktopScrollbarFromPixels={600}>
						<NavigationWrapper>
							<SessionWrapper
								entryPoint={{
									pageIfValid: routes.loginAgent,
									pageIfInvalid: routes.loginAgent,
								}}
							>
								<AgentProvider>
									<EntityWrappers>{children}</EntityWrappers>
								</AgentProvider>
							</SessionWrapper>
						</NavigationWrapper>
					</UiWrapper>
				</BackendWrapper>
			</EventTrackerWrapper>
		</ApplicationWrapper>
	);
};

export default WrappersComponent;
